<template>
  <table ref="table" class="table table-striped table-hover" style="margin-bottom: 0" :class="tblClass" :style="tblStyle">
    <vue-element-loading :active="show" spinner="bar-fade-scale" color="#FF6700"/>
    <colgroup>
      <col v-if="shouldRenderSelection" style="width: 30px"></col>
      <col v-for="col in columns" :class="col.colClass" :style="col.colStyle"></col>
    </colgroup>
    <slot />
  </table>
</template>
<script>
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'TableFrame',
  components: {VueElementLoading},
  data () {
    return {
      show: false,
    }
  },
  mixins: [props, shouldRenderSelection],
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 0;
      var sh = this.$refs['table'].scrollHeight;
      var st = this.$refs['table'].scrollTop;
      var oh = this.$refs['table'].offsetHeight;
      console.log('scrolling..'+(sh-st-oh+1));
      if(sh-st-oh+1<1) {
          console.log('scrolling2..'+(sh-st-oh+1));
      }
    }
  },
  created () {
    //window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    //window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
